<tips stil="stor" skjulTipshandling="true">
  <p>{{ 'For å importere lager du et regneark med en linje per medlem, med følgende kolonner:'|translate }}</p>
  <table class="formattips">
    <tr>
      <th>{{ 'Epost'|translate }}</th>
      <th>{{ 'Navn'|translate }}</th>
      <th>{{ 'Mobilnummer'|translate }}</th>
      <th>{{ 'Rolle'|translate }}</th>
      <th>{{ 'Rolle startdato'|translate }}</th>
      <th>{{ 'Tilgang'|translate }}</th>
    </tr>
    <tr>
      <td>{{ 'tekst (påkrevet)'|translate }}</td>
      <td>{{ 'tekst'|translate }}</td>
      <td>{{ 'tekst (telefonnummer med landkode)'|translate }}</td>
      <td>{{ 'en av verdiene {verdier}'|translate:{verdier: medlemsrollerSomStreng()} }}</td>
      <td>{{ 'dato formatert som {format}'|translate:{format: forventetDatoformat()} }}</td>
      <td>{{ 'en av verdiene {verdier}'|translate:{verdier: tilgjengeligeTilgangsrollerSomStreng()} }}</td>
    </tr>
  </table>
  <p>{{'Marker og kopier linjen du ønsker å importere og lim så teksten inn i feltet under.'|translate}}</p>
</tips>

<mat-form-field class="liminnfelt">
  <mat-label>{{ 'Lim inn fra regneark her'|translate }}</mat-label>
  <input matInput (paste)="vedLimInn($event)" autofocus #liminnfelt data-testid="liminnfelt">
</mat-form-field>

@if(parser != null && parser?.status !== parseStatus.ok){
  <div class="parsefeil">
    <i class="icon ion-android-warning" style="color:#ffac31"></i>
    @switch (parser?.status){
      @case (parseStatus.tom){
        {{'Innlimte data er tomme'|translate}}
      }
      @case (parseStatus.ikkeInvitasjonerInnliming){
        {{'Feil format på innlimte data'|translate}}
      }
      @case (parseStatus.ikkeTekstInnliming){
        {{'Innlimte data inneholdt ingen tekst'|translate}}
      }
      @case (parseStatus.feilantallkolonner){
        {{'Linje {linjenr} inneholder feil antall kolonner'|translate:{linjenr:parser.feiletLinje} }}
      }
    }
    <div class="innlimte-data">{{parser.innlimteData}}</div>
  </div>
}

@if(skjema.controls.length > 0){
  <table class="invitasjonerskjema e2e-invitasjoner">
    <medlem-importer-skjemaoverskrifter [skjema]="skjema" [alleValgt]="alleValgt()" [ingenValgt]="ingenValgt()" (endreAlle)="endreAlle()"/>
    <tbody>
      @for(linje of skjema.controls; track linje){
        <medlem-importer-skjemalinje [skjema]="linje" [medlemsroller]="medlemsroller()"/>
      }
    </tbody>
  </table>
}
